export default __webpack_public_path__ + "static/media/higher_primary_logo_url_tagline.54a1cf49.svg";